import { useIntl } from 'react-intl';
import { Route, Routes } from 'react-router-dom';

import { navigateToMyFiles } from 'router/navigation';

import { DocumentTitle, ErrorView, IntlErrorBoundary, Sidebar } from '_common/components';
import GroupsPage from './pages/GroupsPage/GroupsPage';

import styles from './GroupsContainer.module.scss';

const GroupsContainer = () => {
  const intl = useIntl();
  return (
    <div className={styles.root}>
      <Sidebar />
      <Routes>
        <Route
          index
          element={
            <DocumentTitle
              title={`doDOC - ${intl.formatMessage({
                id: 'storage.sidebar.groups',
              })}`}
            >
              <IntlErrorBoundary size="xl" style={{ margin: '21rem auto 0 auto' }}>
                <GroupsPage />
              </IntlErrorBoundary>
            </DocumentTitle>
          }
        />

        <Route
          path="*"
          element={
            <ErrorView
              error={{
                status: 404,
              }}
              onClick={navigateToMyFiles}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default GroupsContainer;
